module.exports = __webpack_public_path__ + "img/photo-0119.38186752.jpg";